function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Badge } from 'reactstrap';
import 'simple-line-icons/css/simple-line-icons.css';
import 'font-awesome/css/font-awesome.min.css';

var logdown = require('logdown');
var console = logdown('rx-core-badge', { prefixColor: '#d84315' });

export var RXBadge = function (_Component) {
    _inherits(RXBadge, _Component);

    function RXBadge(props) {
        _classCallCheck(this, RXBadge);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        var children = _this.props.children === undefined ? "default text" : _this.props.children;

        _this.state = {
            children: children
        };
        return _this;
    }

    RXBadge.prototype.render = function render() {
        return React.createElement(
            Badge,
            { color: 'primary', style: { padding: 0, marginRight: 10 } },
            React.createElement(
                'span',
                { style: { paddingTop: '.25rem', paddingBottom: '.25rem', paddingLeft: '.4em', fontWeight: 700 }, className: 'float-left' },
                this.state.children
            ),
            React.createElement(
                'span',
                {
                    className: 'float-right',
                    style: {
                        position: 'relative',
                        right: '-.4em',
                        paddingRight: '.4em',
                        paddingLeft: '.4em',
                        paddingTop: '.25rem',
                        paddingBottom: '.25rem',
                        backgroundColor: 'darkBlue',
                        color: "white",
                        borderTopRightRadius: '.25rem',
                        borderBottomRightRadius: '.25rem',
                        cursor: 'pointer'
                    },
                    onClick: this.props.onClick
                },
                React.createElement('i', { className: 'fa fa-close', style: { fontWeight: 400 } })
            )
        );
    };

    return RXBadge;
}(Component);

RXBadge.defaultProps = {
    onClick: function onClick() {
        console.log('default clicked');
    }

    // module.exports = {
    //     RXBadge: RXBadge
    // }

};